import type { SVGProps } from 'react';
const SvgIconOnboarding = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M4.15 1h-.3A2.85 2.85 0 0 0 1 3.85v.3c0 1.368.964 2.511 2.25 2.787v1.126A2.85 2.85 0 0 0 1 10.85v.3c0 1.368.964 2.511 2.25 2.787V15h1.5v-1.063A2.85 2.85 0 0 0 7 11.15v-.3a2.85 2.85 0 0 0-2.25-2.787V6.937A2.85 2.85 0 0 0 7 4.15v-.3A2.85 2.85 0 0 0 4.15 1M2.5 3.85c0-.746.604-1.35 1.35-1.35h.3c.746 0 1.35.604 1.35 1.35v.3A1.35 1.35 0 0 1 4.15 5.5h-.3A1.35 1.35 0 0 1 2.5 4.15zm0 7c0-.746.604-1.35 1.35-1.35h.3c.746 0 1.35.604 1.35 1.35v.3a1.35 1.35 0 0 1-1.35 1.35h-.3a1.35 1.35 0 0 1-1.35-1.35z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M14.777 2.06a.75.75 0 0 1 0 1.06l-2.829 2.83a.75.75 0 0 1-1.06 0L9.12 4.18a.75.75 0 1 1 1.06-1.06l1.238 1.237 2.298-2.298a.75.75 0 0 1 1.06 0m.001 8.061a.75.75 0 1 0-1.061-1.06l-2.298 2.298-1.238-1.238a.75.75 0 0 0-1.06 1.061l1.768 1.768a.75.75 0 0 0 1.06 0z"
    />
  </svg>
);
export default SvgIconOnboarding;
